import { useEffect } from 'react';

/**
 * Hook personalizado para cambiar el favicon dinámicamente
 * @param faviconUrl - URL del favicon a establecer
 */
export const useFavicon = (faviconUrl: string | undefined) => {
  useEffect(() => {
    if (!faviconUrl) return;

    // Buscar el favicon existente
    let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    
    if (!favicon) {
      // Si no existe, crear uno nuevo
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }

    // Actualizar la URL del favicon
    favicon.href = faviconUrl;

    // También actualizar el apple-touch-icon si existe
    let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]') as HTMLLinkElement;
    if (!appleTouchIcon) {
      appleTouchIcon = document.createElement('link');
      appleTouchIcon.rel = 'apple-touch-icon';
      document.head.appendChild(appleTouchIcon);
    }
    appleTouchIcon.href = faviconUrl;

    // Limpiar cuando el componente se desmonte
    return () => {
      // Opcional: restaurar el favicon por defecto si es necesario
      // favicon.href = '/default-favicon.ico';
    };
  }, [faviconUrl]);
};
